export default __webpack_public_path__ + "static/media/mobile_reward1_detail_5-left.636cf48a.svg";